import React from 'react'
import { Block } from './styles'

interface Props {
  children: React.ReactNode
}

const BlockElement = (props: Props): JSX.Element => {
  return <Block>{props.children}</Block>
}

export default BlockElement
